import { PORTAL_CONTAINER_ATTRIBUTE } from './config';

function createPortalContainer() {
    const portalContainer = document.createElement('div');

    portalContainer.setAttribute(PORTAL_CONTAINER_ATTRIBUTE, '');

    document.body.appendChild(portalContainer);

    return portalContainer;
}

export function getPortalContainer() {
    const portalContainer = document.querySelector(`[${PORTAL_CONTAINER_ATTRIBUTE}]`);

    if (portalContainer) {
        return portalContainer;
    }

    return createPortalContainer();
}
